module.exports = __webpack_public_path__ + "img/37.3cd32f3c.png";